<template>
  <div class="contract-management">
    <p class="status" v-if="form.merchantStatus">
      {{ form.merchantStatus | formatCheckStatus }}
      <span
        v-if="form.merchantStatus === '3'"
        class="look-reason"
        @click="reason"
      >
        查看原因
      </span>
    </p>
    <div class="relative">
      <div class="pad-mar__title company-info">
        <h3 class="title">
          企业基本信息
        </h3>
        <div class="form-wrapper flex">
          <el-form label-position="right" label-width="auto" :model="form">
            <el-form-item label="统一社会信用代码：">
              <div class="input">
                <el-input v-model="form.code" placeholder="请输入" clearable />
              </div>
            </el-form-item>
            <el-form-item label="企业名称：">
              <div class="input">
                <el-input
                  v-model="form.companyName"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
            <el-form-item label="企业英文名称：">
              <div class="input">
                <el-input
                  v-model="form.companyEnName"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
            <el-form-item label="营业执照有效日期：">
              <div class="input">
                <el-date-picker
                  v-model="form.validTime"
                  type="date"
                  placeholder="选择日期"
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  clearable
                />
              </div>
            </el-form-item>
          </el-form>
          <el-form label-position="right" label-width="auto" :model="form">
            <el-form-item label="企业法人：">
              <div class="input">
                <el-input
                  v-model="form.legalPerson"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
            <el-form-item label="法人身份证：">
              <div class="input">
                <el-input
                  v-model="form.idCard"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
            <el-form-item label="联系人电话：">
              <div class="input">
                <el-input v-model="form.phone" placeholder="请输入" clearable />
              </div>
            </el-form-item>
            <el-form-item label="联系人邮箱：">
              <div class="input">
                <el-input v-model="form.email" placeholder="请输入" clearable />
              </div>
            </el-form-item>
          </el-form>
          <el-form label-position="right" label-width="auto" :model="form">
            <el-form-item label="开户名：">
              <div class="input">
                <el-input
                  v-model="form.accountName"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
            <el-form-item label="开户行名称：">
              <div class="input">
                <el-input
                  v-model="form.bankName"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
            <el-form-item label="银行账号：">
              <div class="input">
                <el-input
                  v-model="form.bankAccount"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
            <el-form-item label="开户行地址：">
              <div class="input">
                <el-input
                  v-model="form.bankAddress"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </el-form-item>
          </el-form>
        </div>
        <el-form label-position="right" label-width="auto" :model="form">
          <el-form-item label="公司经营地址详细：">
            <div class="input" style="width:40rem">
              <el-input v-model="form.address" placeholder="请输入" clearable />
            </div>
          </el-form-item>
        </el-form>
        <h3 class="title" style="margin-top: 5rem">
          上传附件
          <span class="sub-title">
            (营业执照/身份证正面/身份证反面)
          </span>
        </h3>
        <div class="upload-file" :class="form.merchantStatus !== '2' && 'del'">
          <el-upload
            action="/"
            class="upload"
            ref="uploadImg"
            list-type="picture-card"
            accept=".jpg,.jpeg,.png"
            :limit="10"
            :on-exceed="handleExceed"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove.bind(null, 'form.merchantList')"
            :http-request="
              _appendFormDataInfo.bind(null, form.merchantList, 'merchant_file')
            "
            :file-list="form.merchantList"
            :before-upload="_beforeLimitUpload"
            :on-change="handleAddItemData.bind(null, 'form.merchantList')"
            :auto-upload="false"
          >
            <div class="winner-flex">
              <el-button size="36" class="iconfont icon-tupian d5" round />
              <span class="tips">
                上传附件
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <div class="img-viewer">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </div>
          </el-dialog>
        </div>
      </div>
      <div class="pad-mar__title brand-info">
        <h3 class="title">品牌信息</h3>
        <div class="form-wrapper">
          <el-form label-position="right" label-width="auto" :model="form">
            <el-form-item label="商标所在国别：">
              <div class="input">
                <el-select
                  placeholder="请选择"
                  clearable
                  v-model="form.trademarkCountry"
                >
                  <el-option
                    v-for="item in filterDownData('countryList')"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="商标类型：">
              <div class="input">
                <el-select
                  placeholder="请选择"
                  clearable
                  v-model="form.trademarkType"
                >
                  <el-option
                    v-for="item in filterDownData('trademartksList')"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="商标申请/注册号：">
              <div class="input">
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="form.trademarkApplication"
                />
              </div>
            </el-form-item>
            <el-form-item label="品牌名称：">
              <div class="input" style="display: block;margin-bottom: 1rem">
                <el-input
                  placeholder="请输入中文名"
                  clearable
                  v-model="form.brandCnName"
                />
              </div>
              <div class="input">
                <el-input
                  placeholder="请输入英文名"
                  clearable
                  v-model="form.brandEnName"
                />
              </div>
            </el-form-item>
            <el-form-item label="资质类型：">
              <el-radio-group v-model="form.qalificationType">
                <el-radio label="1"> 商标注册证</el-radio>
                <el-radio label="2"> 商标受理通知书</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="商标有效期：">
              <div class="input-box">
                <div class="input">
                  <el-date-picker
                    v-model="form.time"
                    type="daterange"
                    unlink-panels
                    range-separator="至 "
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="商标注册人：">
              <div class="input">
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="form.trademarkRegistrant"
                />
              </div>
            </el-form-item>
            <el-form-item label="品牌类型：">
              <div class="input">
                <el-select
                  placeholder="请选择"
                  clearable
                  v-model="form.brandType"
                >
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="item in filterDownData('brandType')"
                    :key="item.value"
                  />
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="商家经营商品清单：">
              <div
                class="upload-file excel"
                :class="form.merchantStatus !== '2' && 'del'"
              >
                <el-upload
                  action="/"
                  ref="uploadFile"
                  :on-remove="handleRemove.bind(null, 'form.fileData')"
                  :limit="1"
                  accept=".xls,.xlsx"
                  :before-upload="_beforeLimitUpload"
                  :http-request="
                    _appendFormDataInfo.bind(
                      null,
                      form.fileData,
                      'commodities_list_url'
                    )
                  "
                  :on-change="handleAddItemData.bind(null, 'form.fileData')"
                  :file-list="form.fileData"
                  :auto-upload="false"
                >
                  <el-button size="medium" class="sub-color">上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    （只能上传excel文件）
                  </div>
                </el-upload>
              </div>
              <fragment v-if="form.fileData.length >= 1">
                <i class="el-icon-download"></i>
                <a class="download" :href="form.listUrl" download>
                  下载文件
                </a>
              </fragment>
            </el-form-item>
          </el-form>
        </div>
        <h3 class="title" style="margin-top: 5rem">
          上传附件
          <span class="sub-title">
            商标注册证/品牌授权书/公司资质文件上传区域（请务必将资质文件作为第一张上传，作为主要审核之用）
          </span>
        </h3>
        <div class="upload-file" :class="form.merchantStatus !== '2' && 'del'">
          <el-upload
            action="/"
            class="upload"
            ref="upload"
            list-type="picture-card"
            accept=".jpg,.jpeg,.png"
            :limit="10"
            :on-exceed="handleExceed"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove.bind(null, 'form.fileList')"
            :http-request="
              _appendFormDataInfo.bind(null, form.fileList, 'brand_file')
            "
            :file-list="form.fileList"
            :before-upload="_beforeLimitUpload"
            :on-change="handleAddItemData.bind(null, 'form.fileList')"
            :auto-upload="false"
          >
            <div class="winner-flex">
              <el-button size="36" class="iconfont icon-tupian d5" round />
              <span class="tips">
                上传附件
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <div class="img-viewer">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </div>
          </el-dialog>
        </div>
      </div>

      <fragment v-if="form.merchantStatus !== '2'">
        <div class="bg-color__fff">
          <el-checkbox
            v-model="join"
            label="已阅读酒加-第三方入驻合同，并同意相关条款"
          />
          <a href="#" class="download">
            预览合同
          </a>
          <i class="el-icon-download" style="margin-left: 1rem" />
          <a class="download" href="#" download>
            下载模板
          </a>
        </div>
        <div class="btn-all">
          <el-button
            size="98"
            class="sub-color"
            @click="saveData"
            v-permission:save="$route.meta.permission"
          >
            保存
          </el-button>
        </div>
      </fragment>
    </div>
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'
import filterDownData from 'mixins/filterDownData'
import uploadImg from 'mixins/uploadImg'

export default {
  name: 'contractManagement',
  mixins: [pickerOptions, filterDownData, uploadImg],
  data() {
    this.keyMap = {
      merchant_info: {
        name: 'form',
        credit_code: 'code',
        enterprise_name: 'companyName',
        enterprise_en_name: 'companyEnName',
        license_date: 'validTime',
        enterprise_address: 'address',
        legal_person: 'legalPerson',
        id_number: 'idCard',
        mobile_phone: 'phone',
        mail_box: 'email',
        account_name: 'accountName',
        bank_account: 'bankAccount',
        bank_name: 'bankName',
        bank_address: 'bankAddress',
        country_id: 'trademarkCountry',
        type_id: 'trademarkType',
        brand_id: 'brandId',
        brand_mark: 'trademarkApplication',
        chinese_name: 'brandCnName',
        english_name: 'brandEnName',
        start_time: 'startTime',
        end_time: 'endTime',
        trademark_registrant: 'trademarkRegistrant',
        brand_type: 'brandType',
        qualification_type: 'qalificationType',
        brand_image: 'fileList',
        file_data: 'fileData',
        merchant_image: 'merchantList',
        merchant_state: 'merchantStatus',
        merchant_id: 'merchantId',
        rejection_reason: 'reason',
        picture_url: 'url',
        album_id: 'albumId',
        picture_id: 'picId',
        picture_name: 'picName',
        use_state: 'useState',
        status: 'status',
        commodities_list_url: 'listUrl'
      }
    }
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      join: false,
      form: {
        merchantStatus: '',
        code: '',
        companyName: '',
        companyEnName: '',
        validTime: '',
        address: '',
        legalPerson: '',
        idCard: '',
        phone: '',
        email: '',
        bankName: '',
        accountName: '',
        bankAddress: '',
        banckAccount: '',
        trademarkApplication: '',
        brandCnName: '',
        brandEnName: '',
        qalificationType: '',
        time: [],
        trademarkRegistrant: '',
        brandType: '',
        countryId: '',
        fileData: [],
        fileList: [],
        merchantList: [],
        merchantId: '',
        reason: ''
      }
    }
  },

  watch: {
    $route: {
      handler(to) {
        const id = to.query.id
        if (id) this._getMerchantCheckState({ merchant_id: id })
        else this._getMerchantCheckState()
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 保存信息
     */
    saveData() {
      if (!this.join) {
        this.$notify({
          type: 'warning',
          message: '请同意酒加第三方入驻协议合同~！🤲'
        })
        return
      }
      this.utils._setNewTime(this, 'form')
      const newMap = this.utils._reverseObj(this.keyMap)
      const data = {
        form: this.utils._cloneDeep(this.form)
      }
      this.utils._modifyObjKey(data, newMap)
      this._handleUpload('uploadImg', 'uploadFile', 'upload')
      this.formData.append('data', JSON.stringify(data.merchant_info))

      if (this.isUpload) {
        this.api.saveMerchantFormData(this.formData).then(() => {
          this.$notify({
            type: 'success',
            message: '已提交审核~！🙂'
          })
          this._getMerchantCheckState()
        })
      }
    },
    /**
     * 查看原因
     */
    reason() {
      this.$confirm(this.form.reason, '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '重新编辑',
        showClose: false,
        cancelButtonClass: 'el-button--98',
        confirmButtonClass: 'el-button--98 sub-color',
        type: 'warning',
        center: true
      })
        .then(() => {})
        .catch(() => {})
    },
    /**
     * 获取商家审核状态
     */
    _getMerchantCheckState(params) {
      this.api.getMerchantCheckState(params).then(res => {
        if (res.merchant_info === '') return
        this.utils._modifyObjKey(res, this.keyMap)
        this.form = res.form
        this.utils._mergeTime(this, 'form')
      })
    }
  }
}
</script>
<style lang="scss">
.contract-management {
  .status {
    width: 100%;
    height: 3.1rem;
    background-color: colors('bg-sub');
    color: #fff;
    text-align: center;
    line-height: 3.1rem;
    margin-bottom: 1.3rem;
  }

  .company-info {
    min-height: 55rem;
  }

  .flex {
    display: flex;

    .el-form {
      flex: 1;
    }
  }

  .upload {
    .el-upload--picture-card {
      width: 12.5rem;
      height: 12.5rem;
      border: 0;
      background-color: #f7f7f7;
      line-height: initial;
    }

    .winner-flex {
      height: 100%;
      flex-direction: column;
    }

    .el-upload-list__item {
      width: 12.5rem;
      height: 12.5rem;
      border: 0;
    }

    .tips {
      padding-top: 0.5rem;
    }
  }

  .upload-file {
    .el-upload-list {
      .el-icon-close {
        display: none;
      }
    }

    .el-icon-delete {
      display: none;
    }

    &.excel {
      width: 20rem;
    }

    &.del {
      .el-icon-delete {
        display: block;
      }
    }
  }

  .el-icon-download {
    font-size: 16px;
    /*margin: 0 0.5rem 0 2.8rem;*/
  }

  .download {
    text-decoration: underline;
    color: #000;
  }

  .brand-info {
    min-height: 79rem;
  }

  .bg-color__fff {
    height: 5rem;
    line-height: 5rem;
    padding-left: 5.6rem;
  }

  .btn-all {
    margin: 4rem 0;
    width: 100%;
    text-align: center;
  }

  .look-reason {
    text-decoration: underline;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>
